import * as React from 'react';
import { SVGProps } from 'react';

export const Plant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9999 28.7425C12.1111 29.5775 12.6249 30.1837 13.2274 30.1837H20.5749C21.1749 30.1837 21.6911 29.5775 21.8011 28.7425L23.2061 20.45C23.3 20.0435 23.252 19.6171 23.0701 19.2417C22.8882 18.8663 22.5833 18.5644 22.2061 18.3862C22.1307 18.3663 22.0529 18.3562 21.9749 18.3562H11.8174C11.1274 18.3562 10.5674 19.1475 10.5674 20.1237C10.5674 20.2328 10.5749 20.3418 10.5899 20.45L11.9999 28.7425Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5287 17.9762C14.6004 13.7593 12.5052 9.88824 9.48242 6.80493"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2851 5.50001C17.2463 8.84376 17.1713 11.9463 15.2201 13.6738C13.2688 15.4013 10.1801 15.1 7.22005 11.7563C4.26005 8.41251 3.44005 4.30626 5.3913 2.57876C7.34255 0.851261 11.3251 2.16126 14.2851 5.50001Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.564 18.3562C20.2027 16.3224 20.0715 14.5237 22.1427 11.3462"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7676 7.915C18.5001 10.6162 18.6251 13.0612 20.2064 14.3825C21.7876 15.7037 24.2064 15.3987 26.4751 12.6975C28.7439 9.99625 29.2951 6.73625 27.7251 5.41625C26.1551 4.09625 23.0301 5.215 20.7676 7.915Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Plant;
